<template>
  <component
    @onmacrocall="onMacroCall"
    :macroList="macroList"
    v-bind="$props"
    :is="view"
  ></component>
</template>
<script>
import { loadScript } from "../../utility/loadScript.js";
import { isFunction, isPromise, isUndef } from "../../utility/utilityfunctions";
import MacroFilterSection from "./views/macro-filter-section";
import MacroFormSection from "./views/macro-form-section";
import MacroNavigationSection from "./views/macro-navigation-section";

export default {
  name: "MacroComponent",
  components: {
    MacroFormSection,
    MacroFilterSection,
    MacroNavigationSection,
  },
  props: {
    view: {
      type: String,
      validator: function (value) {
        // The value must match one of these strings
        return (
          [
            "macro-form-section",
            "macro-filter-section",
            "macro-navigation-section",
          ].indexOf(value) !== -1
        );
      },
      default: "macro-form-section",
    },
    route: {
      type: String,
      required: true,
    },
    reference: {
      type: String,
      default: "",
    },
    setTargetThisRefence: {
      type: Function,
    },
  },
  data() {
    return {
      list: [],
      macro: {},
    };
  },
  computed: {
    macroList: {
      get() {
        return this.list;
      },
      set(arr) {
        this.list = arr;
      },
    },
  },
  methods: {
    onMacroCall(macroname) {
      if (isFunction(this.setTargetThisRefence)) {
        if (this.reference)
          return this.macro.call(
            macroname,
            this.setTargetThisRefence()(this.reference)
          );
        return this.macro.call(macroname, this.setTargetThisRefence()());
      }
      return this.macro.call(macroname, this.$parent);
    },
  },
  created() {
    const _this = this;
    function initiate() {
      if (isUndef(_this.macro) || !isFunction(_this.macro.list)) return;
      const list = _this.macro.list();
      isPromise(list) &&
        list.then((res) => {
          _this.$set(
            _this,
            "macroList",
            (res || []).filter((item) => item.route == _this.route)
          );
        });
    }
    loadScript(this.macroJSFileUrl)
      .then(function (el) {
        _this.macro = window["_macro"];
        if (el.isUpdated) {
          _this.macro.init(_this.appName);
        }
        initiate();
      })
      .catch((error) => {
        _this.$set(_this, "macroList", []);
        console.error("Macro is not configured ...", error);
      });
  },
};
</script>